<template lang="html">
  <span @click="openModal">
    <Icon
      v-if="!tooltip"
      icon="icon-park-solid:info"
      :title="tut_name"
      class="icon"
    />
    <Icon
      v-else
      icon="icon-park-solid:info"
      class="icon"
      v-tooltip="tut_text"
    />
  </span>
</template>

<script>
import { Icon } from "@iconify/vue2";
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
export default {
  neme: "Questionmark",
  components: {
    Icon
  },
  props: {
    id: {
      required: false,
      type: Number
    },
    toast: {
      required: false,
      default: false,
      type: Boolean
    },
    tooltip: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      tut_name: null,
      tut_text: null
    };
  },
  mounted() {
    this.getHelpMessage();
  },
  methods: {
    getHelpMessage() {
      let params = {
        tut_id: this.id
      };
      api
        .getTutorial(params)
        .then(res => {
          let tut = res.data.data[0];
          this.tut_name = tut.tut_name;
          this.tut_text = tut.tut_text;
        })
        .catch(e => {
          console.log(e);
        });
    },
    openModal() {
      if (this.tooltip) return;
      console.log("open modal");
      if (this.toast) {
        this.$toast.default(this.tut_text, {
          duration: 20000,
          dismissable: true,
          pauseOnHover: true
        });
      } else {
        let modalData = {
          title: this.tut_name,
          description: this.tut_text
        };
        let params = {
          modalData: modalData,
          component: "questionmarkModal"
        };
        eventBus.$emit("openModal", params);
      }
    }
  },
  watch: {
    "$route.params.lang": function() {
      this.getHelpMessage();
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  font-size: 2rem;
  max-height: 20px;
  max-width: 20px;
  margin: auto 5px;
  color: $light-blue-500;
  cursor: pointer;
  transform: translateY(5px);
  outline: none;
}
</style>
